(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boton-whatsapp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var boton = document.querySelector('.spw-wa');
    if (!boton) return;
    var segundos = parseInt(boton.getAttribute('data-segundos'), 10);
    if (isNaN(segundos) || segundos < 1) segundos = 4;
    window.setTimeout(function () {
      boton.classList.add('spw-wa--colapsado');
    }, segundos * 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  (function () {
    var wrapper = document.querySelector('.header-wrapper.encabezado-transparente');
    if (wrapper) {
      var actualizarEstado = function () {
        if (window.scrollY > 40) {
          wrapper.classList.add('encabezado-activo');
        } else {
          wrapper.classList.remove('encabezado-activo');
        }
      };
      actualizarEstado();
      window.addEventListener('scroll', actualizarEstado, { passive: true });
    }

    var menusHover = document.querySelectorAll('.header-wrapper.abrir-menu-hover header-menu');
    if (menusHover.length) {
      var consultaDesktop = window.matchMedia('(min-width: 990px)');
      menusHover.forEach(function (menu) {
        var detalle = menu.querySelector('details');
        if (!detalle) return;
        menu.addEventListener('mouseenter', function () {
          if (!consultaDesktop.matches) return;
          menusHover.forEach(function (otro) {
            var otroDetalle = otro.querySelector('details');
            if (otroDetalle && otroDetalle !== detalle) otroDetalle.open = false;
          });
          detalle.open = true;
        });
        menu.addEventListener('mouseleave', function () {
          if (!consultaDesktop.matches) return;
          detalle.open = false;
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-nuevo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carriles = document.querySelectorAll('.spn-carril');
    carriles.forEach(function (carril) {
      var riel = carril.querySelector('.spn-riel');
      var prev = carril.querySelector('.spn-flecha--prev');
      var next = carril.querySelector('.spn-flecha--next');
      if (!riel) return;

      function paso() {
        var t = riel.querySelector('.spn-tarjeta');
        return t ? t.offsetWidth + 31 : riel.clientWidth * 0.8;
      }
      function actualizar() {
        var max = riel.scrollWidth - riel.clientWidth - 2;
        if (prev) prev.classList.toggle('spn-flecha--oculta', riel.scrollLeft <= 2);
        if (next) next.classList.toggle('spn-flecha--oculta', riel.scrollLeft >= max);
      }
      if (prev) {
        prev.addEventListener('click', function () {
          riel.scrollBy({ left: -paso(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          riel.scrollBy({ left: paso(), behavior: 'smooth' });
        });
      }
      riel.addEventListener('scroll', actualizar, { passive: true });
      window.addEventListener('resize', actualizar);
      actualizar();

      var abajo = false;
      var xInicio = 0;
      var scrollInicio = 0;
      var movido = false;
      riel.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        abajo = true;
        movido = false;
        xInicio = e.clientX;
        scrollInicio = riel.scrollLeft;
        riel.style.scrollSnapType = 'none';
      });
      window.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        var d = e.clientX - xInicio;
        if (Math.abs(d) > 4) movido = true;
        riel.scrollLeft = scrollInicio - d;
      });
      window.addEventListener('pointerup', function () {
        if (!abajo) return;
        abajo = false;
        riel.style.scrollSnapType = '';
      });
      riel.addEventListener('click', function (e) {
        if (movido) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
